import React from "react";
import ReactDOM from "react-dom/client";
import AppSingle from "./AppSingle";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppSingle />);
